import { oldPkg } from 'ynf-core-loader';
import { err, upperFirst } from './report';
const loadPromiseCached = {}

export default async function loadYNF (apiStr, { errReport = true } = {}) {
  try {
    const splitIndex = apiStr.indexOf('/')
    const packageName = ~splitIndex ? apiStr.substr(0, splitIndex) : apiStr
    const entry = ~splitIndex ? `./${apiStr.substr(splitIndex + 1)}` : '.'
    let scope = packageName.split('-').map(v => upperFirst(v)).join('')
    // 合包关系映射处理
    if (oldPkg[scope]) {
      scope = oldPkg[scope];
    }
    const cacheKey = `${packageName}_${scope}`
    let containerPromise = loadPromiseCached[cacheKey]
    if (!containerPromise) {
      containerPromise = loadPromiseCached[cacheKey] = window.tnsSdk.asyncLoadPackage({ providerPackage: packageName, providerName: scope })
    }
    await containerPromise
    // eslint-disable-next-line
    await __webpack_init_sharing__('default')
    const container = window[scope] // or get the container somewhere else
    if (!container) throw new Error('')
    // eslint-disable-next-line
    await container.init(__webpack_share_scopes__.default)
    const factory = await window[scope].get(entry)
    let Module = factory()
    if (Module?.default) {
      Module = Module.default
    }
    return Module
  } catch (error) {
    errReport && err(`加载YNF资源 ${apiStr} 出错：`, error)
  }
}
